
import React, { useState, useRef } from 'react';
import { TrendingUp, Users, Heart, Zap, Award, Target, X, Upload } from 'lucide-react'; 
import Image1 from "../assets/careers1.webp"
import Image2 from "../assets/careers2.webp"
import Image3 from "../assets/careers3.webp"
import Image4 from "../assets/careers4.jpg"
import Image5 from "../assets/careers5.webp"
import Image6 from "../assets/careers6.webp"
import Image7 from "../assets/careers7.webp"
import Image8 from "../assets/careers8.webp"

const JOBS_DATA = [
  {
    id: 1,
    title: "Software Developer",
    category: "Development",
    location: "Ghaziabad, India",
    type: "Full-time",
    experience: "2+ years experience",
    description: "Design, build, and maintain scalable software applications. Collaborate with cross-functional teams to deliver robust tech solutions.",
    iconColor: "text-blue-600",
    bgColor: "bg-blue-50",
    hoverColor: "group-hover:text-blue-600",
    icon: (
      <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    )
  },
  {
    id: 2,
    title: "Web Designer",
    category: "Design",
    location: "Ghaziabad, India",
    type: "Full-time",
    experience: "2+ years experience",
    description: "Create visually engaging and responsive website layouts. Ensure user-friendly interfaces and seamless user experiences.",
    iconColor: "text-purple-600",
    bgColor: "bg-purple-50",
    hoverColor: "group-hover:text-purple-600",
    icon: (
      <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
      </svg>
    )
  },
  {
    id: 3,
    title: "Internet Marketer",
    category: "Marketing",
    location: "Ghaziabad, India",
    type: "Remote", 
    experience: "2+ years experience",
    description: "Develop and execute digital marketing campaigns. Optimize SEO, social media, and paid ads to boost brand visibility.",
    iconColor: "text-rose-600",
    bgColor: "bg-rose-50",
    hoverColor: "group-hover:text-rose-600",
    icon: (
      <svg className="w-6 h-6 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
      </svg>
    ),
    tagColor: "bg-blue-50 text-blue-700"
  },
  {
    id: 4,
    title: "Salespeople",
    category: "Sales",
    location: "Ghaziabad, India",
    type: "Full-time",
    experience: "2+ years experience",
    description: "Generate leads, pitch products or services, and close sales. Build strong client relationships and meet monthly targets.",
    iconColor: "text-amber-600",
    bgColor: "bg-amber-50",
    hoverColor: "group-hover:text-amber-600",
    icon: (
      <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  },
  {
    id: 5,
    title: "Support People",
    category: "Support",
    location: "Ghaziabad, India",
    type: "Full-time",
    experience: "2+ years experience",
    description: "Assist customers with inquiries, troubleshoot issues, and provide timely resolutions. Ensure high levels of customer satisfaction.",
    iconColor: "text-indigo-600",
    bgColor: "bg-indigo-50",
    hoverColor: "group-hover:text-indigo-600",
    icon: (
      <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    )
  },
  {
    id: 6,
    title: "Project Manager",
    category: "Management",
    location: "Ghaziabad, India",
    type: "Full-time",
    experience: "3+ years experience",
    description: "Plan, coordinate, and oversee projects from initiation to completion. Manage team tasks, timelines, and stakeholder communication.",
    iconColor: "text-teal-600",
    bgColor: "bg-teal-50",
    hoverColor: "group-hover:text-teal-600",
    icon: (
      <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    )
  }
];

const CATEGORIES = ["All", "Development", "Design", "Marketing", "Sales", "Support", "Management"];

export const Careers = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  // State for Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  // Ref for scrolling
  const positionsRef = useRef(null);

  const filteredJobs = activeCategory === "All" 
    ? JOBS_DATA 
    : JOBS_DATA.filter(job => job.category === activeCategory);

  // Scroll function
  const scrollToPositions = () => {
    positionsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Open Modal function
  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };

  // Close Modal function
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedJob(null);
  };

  return (
    <div className="min-h-screen bg-[#EEF2FC]">
      {/* Hero Section */}
      <section className="relative flex flex-col items-center justify-start min-h-screen px-4 pt-28 md:pt-36 pb-16">

        {/* Decorative image placeholders - Left side */}
        <div className="absolute left-0 top-28 hidden lg:flex flex-col gap-8 w-60 xl:w-72 pl-4 xl:pl-8">
          <div className="w-full aspect-[6/5] rounded-lg overflow-hidden border border-gray-300">
            <img src={Image1} alt="Team collaboration" className="w-full h-full object-cover" />
          </div>
          <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-gray-300 ml-12 scale-110 translate-y-6">
            <img src={Image2} alt="Workplace environment" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* Center content */}
        <div className="text-center max-w-4xl mx-auto z-10">
          <h1 className="text-lg md:text-xl font-medium text-gray-700 mb-4 tracking-wide">
            Welcome to Eurofox
          </h1>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-8">
            Build Your Future <br className="hidden sm:block" />
            With Us
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Join a team that values innovation, collaboration, and growth.
            Discover opportunities that challenge and inspire you every day.
          </p>
          <div className="mt-12">
            <button 
              onClick={scrollToPositions}
              className="bg-gray-900 text-white px-8 py-3 rounded-lg font-medium  transition-all duration-300 hover:-translate-y-1"
            >
              View Open Positions
            </button>
          </div>
        </div>

        {/* Decorative image placeholders - Right side */}
        <div className="absolute right-0 top-28 hidden lg:flex flex-col gap-8 w-48 xl:w-56 pr-4 xl:pr-8">
          <div className="w-full aspect-[3/4] rounded-lg overflow-hidden border border-gray-300 mr-8 -translate-y-4">
            <img src={Image3} alt="Office space" className="w-full h-full object-cover" />
          </div>
          <div className="w-full aspect-square rounded-lg overflow-hidden border border-gray-300 -translate-x-24 scale-110">
            <img src={Image4} alt="Company culture" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {/* Section 2: Global Innovation - UNCHANGED */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#EEF2FC]">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="text-4xl md:text-5xl font-semibold text-center text-gray-900 mb-16">
            Drive your career forward with global impact
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
            {/* Box 1 */}
            <div className="bg-[#C8D4FF] rounded-3xl p-5 flex flex-col h-full">
              <div className="w-full aspect-[16/10] bg-gray-300 rounded-2xl mb-6 overflow-hidden">
                <img src={Image5} alt="Global team" className="w-full h-full object-cover" />
              </div>
              <div className="flex flex-col flex-grow">
                <h3 className="text-2xl md:text-3xl font-medium text-gray-900 mb-4 leading-tight">
                  Build a global mindset for a connected world
                </h3>
                <p className="text-gray-900 text-medium leading-relaxed">
                  From a local innovator to an international powerhouse, we've expanded by embracing every opportunity. Join our diverse, multicultural team and develop skills that transcend geographical borders.
                </p>
              </div>
            </div>
            {/* Box 2 */}
            <div className="bg-[#C8D4FF] rounded-3xl p-5 flex flex-col h-full">
              <div className="w-full aspect-[16/10] bg-gray-300 rounded-2xl mb-6 overflow-hidden">
                <img src={Image6} alt="Innovation" className="w-full h-full object-cover" />
              </div>
              <div className="flex flex-col flex-grow">
                <h3 className="text-2xl md:text-3xl font-medium text-gray-900 mb-4 leading-tight">
                  Pioneer innovation with the market leader
                </h3>
                <p className="text-gray-900 text-medium leading-relaxed">
                  Develop groundbreaking solutions that define industry benchmarks. Here, your insights don't just contribute—they actively shape the future of our technology and services.
                </p>
              </div>
            </div>
            {/* Box 3 */}
            <div className="bg-[#C8D4FF] rounded-3xl p-5 flex flex-col h-full">
              <div className="w-full aspect-[16/10] bg-gray-300 rounded-2xl mb-6 overflow-hidden">
                <img src={Image7} alt="Teamwork" className="w-full h-full object-cover" />
              </div>
              <div className="flex flex-col flex-grow">
                <h3 className="text-2xl md:text-3xl font-medium text-gray-900 mb-4 leading-tight">
                  One Team Mindset One Winning Outcome.
                </h3>
                <p className="text-gray-900 text-medium leading-relaxed">
                  Success is strongest when achieved together. We empower teams to collaborate openly, challenge ideas, learn continuously, and grow collectively—driven by one team mindset that delivers lasting impact.
                </p>
              </div>
            </div>
            {/* Box 4 */}
            <div className="bg-[#C8D4FF] rounded-3xl p-5 flex flex-col h-full">
              <div className="w-full aspect-[16/10] bg-gray-300 rounded-2xl mb-6 overflow-hidden">
                <img src={Image8} alt="Growth" className="w-full h-full object-cover" />
              </div>
              <div className="flex flex-col flex-grow">
                <h3 className="text-2xl md:text-3xl font-medium text-gray-900 mb-4 leading-tight">
                  Create your future where growth comes naturally
                </h3>
                <p className="text-gray-900 text-medium leading-relaxed">
                  We believe growth happens best in the right environment. By fostering learning, collaboration, and trust, we help you build a future that moves forward naturally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Why Join Our Team - UNCHANGED */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#EEF2FC]">
        <div className="max-w-[1400px] mx-auto">
          {/* Section Heading */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-semibold text-gray-900">
              Why Join Our Team
            </h2>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
              We provide the environment, tools, and culture you need to excel.
            </p>
          </div>

          {/* Grid of 6 Boxes */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            {/* Box 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-start transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:border-blue-100">
              <div className="bg-blue-50 p-3 rounded-xl mb-6">
                <TrendingUp className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Career Growth</h3>
              <p className="text-gray-800 text-medium leading-relaxed">
                Clear paths to leadership and continuous learning opportunities.
              </p>
            </div>

            {/* Box 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-start transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:border-purple-100">
              <div className="bg-purple-50 p-3 rounded-xl mb-6">
                <Users className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Team Culture</h3>
              <p className="text-gray-800 text-medium leading-relaxed">
              Inclusive, collaborative, and supportive environment
              </p>
            </div>

            {/* Box 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-start transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:border-rose-100">
              <div className="bg-rose-50 p-3 rounded-xl mb-6">
                <Heart className="w-8 h-8 text-rose-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Work Life Balance</h3>
              <p className="text-gray-800 text-medium leading-relaxed">
                Flexible schedules that prioritize your personal well-being.
              </p>
            </div>

            {/* Box 4 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-start transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:border-amber-100">
              <div className="bg-amber-50 p-3 rounded-xl mb-6">
                <Zap className="w-8 h-8 text-amber-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Innovation</h3>
              <p className="text-gray-800 text-medium leading-relaxed">
                Access to cutting-edge technology to solve tomorrow's problems.
              </p>
            </div>

            {/* Box 5 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-start transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:border-indigo-100">
              <div className="bg-indigo-50 p-3 rounded-xl mb-6">
                <Award className="w-8 h-8 text-indigo-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Recognition</h3>
              <p className="text-gray-800 text-medium leading-relaxed">
                Competitive compensation and rewards that celebrate your impact.
              </p>
            </div>

            {/* Box 6 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-start transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:border-teal-100">
              <div className="bg-teal-50 p-3 rounded-xl mb-6">
                <Target className="w-8 h-8 text-teal-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Meaningful Impact</h3>
              <p className="text-gray-800 text-medium leading-relaxed">
                Contribute to projects that make a real difference and shape the future.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Open Positions - MODIFIED */}
      <section ref={positionsRef} className="py-20 px-4 sm:px-6 lg:px-8 bg-[#EEF2FC]">
        <div className="max-w-[1400px] mx-auto">
          {/* Section Header with Category Buttons */}
          <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center mb-12 gap-8">
            {/* Left Side - Heading */}
            <div className="xl:w-1/3">
              <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-4">
                Open Positions
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl">
                Find the perfect role to match your expertise.
              </p>
            </div>

            {/* Right Side - Category Filters */}
            <div className="xl:w-2/3 flex flex-wrap justify-end gap-3">
               {CATEGORIES.map((category) => (
                 <button
                   key={category}
                   onClick={() => setActiveCategory(category)}
                   className={`px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 border
                     ${activeCategory === category 
                       ? 'bg-[#C8D4FF] text-black' 
                       : 'bg-white text-gray-800 border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                     }`}
                 >
                   {category}
                 </button>
               ))}
            </div>
          </div>

          {/* Positions Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {filteredJobs.length > 0 ? (
              filteredJobs.map((job) => (
                <div key={job.id} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-4">
                      <div className={`p-3 rounded-xl ${job.bgColor}`}>
                        {job.icon}
                      </div>
                      <div>
                        <h3 className={`text-xl font-bold text-gray-900 transition-colors ${job.hoverColor}`}>
                          {job.title}
                        </h3>
                        <div className="flex items-center gap-2 mt-1">
                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span className="text-gray-600 text-sm">{job.location}</span>
                        </div>
                      </div>
                    </div>
                    <span className={`text-sm font-medium px-3 py-1 rounded-full ${job.tagColor || 'bg-green-50 text-green-700'}`}>
                      {job.type}
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    {job.description}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-4">
                      <span className="text-gray-600 text-sm flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {job.experience}
                      </span>
                    </div>
                    <button 
                      onClick={() => handleApplyClick(job)}
                      className="bg-gray-900 text-white px-5 py-2 rounded-lg font-medium transition-all duration-300 text-sm hover:-translate-y-1"
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              ))
            ) : (
               <div className="col-span-full text-center py-12">
                 <p className="text-gray-500 text-lg">No open positions found in this category.</p>
               </div>
            )}
          </div>
        </div>
      </section>

      {/* Application Modal Popup */}
      {isModalOpen && selectedJob && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-all duration-300">
          <div className="bg-white rounded-2xl w-full max-w-lg p-8 shadow-2xl relative animate-in fade-in zoom-in duration-200">
            {/* Close Button */}
            <button 
              onClick={closeModal}
              className="absolute top-6 right-6 text-gray-400 hover:text-gray-600 transition-colors bg-gray-100 p-2 rounded-full hover:bg-gray-200"
            >
              <X size={20} />
            </button>

            {/* Header */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900">Application</h3>
              <p className="text-gray-600 mt-1">
                Applying for <span className="font-semibold text-gray-900">{selectedJob.title}</span> role
              </p>
            </div>

            {/* Form */}
            <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); alert("Application Submitted!"); closeModal(); }}>
              {/* Full Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Full Name</label>
                <input 
                  type="text" 
                  placeholder="Enter your full name" 
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-gray-900 focus:ring-2 focus:ring-gray-100 outline-none transition-all placeholder-gray-400"
                  required
                />
              </div>

              {/* Email & Mobile Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">Email Address</label>
                  <input 
                    type="email" 
                    placeholder="Enter your email" 
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-gray-900 focus:ring-2 focus:ring-gray-100 outline-none transition-all placeholder-gray-400"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">Mobile No</label>
                  <input 
                    type="tel" 
                    placeholder="Enter your mobile no." 
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-gray-900 focus:ring-2 focus:ring-gray-100 outline-none transition-all placeholder-gray-400"
                    required
                  />
                </div>
              </div>

              {/* Education */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Education</label>
                <input 
                  type="text" 
                  placeholder="eg. B.Tech Computer Science" 
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-gray-900 focus:ring-2 focus:ring-gray-100 outline-none transition-all placeholder-gray-400"
                  required
                />
              </div>

              {/* Resume Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Upload Resume/CV</label>
                <div className="relative border-2 border-dashed border-gray-200 rounded-xl p-6 hover:border-gray-400 transition-colors group cursor-pointer text-center">
                  <input type="file" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" accept=".pdf,.doc,.docx" />
                  <div className="flex flex-col items-center justify-center gap-2 text-gray-500 group-hover:text-gray-700">
                    <div className="p-3 bg-gray-50 rounded-full group-hover:bg-gray-100 transition-colors">
                      <Upload size={20} />
                    </div>
                    <span className="text-sm font-medium">Click to upload or drag and drop</span>
                    <span className="text-xs text-gray-400">PDF, DOC (Max 5MB)</span>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                className="w-full bg-gray-900 text-white py-3.5 rounded-xl font-medium transform active:scale-[0.98] transition-all duration-300 shadow-lg shadow-gray-200 mt-2 hover:-translate-y-1"
              >
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};